import { $window } from '@umu/umu-dom';
import { isAndroid, isIos, isSafari } from '@umu/umu-ua';
import { fetchData } from '@umu/umu-fetch';
import { API_TYPE } from '@umu/umu-types';

export interface GetProfileUrlParams {
    umu_id?: string;
    student_id?: string;
}

const GET_PROFILE_URL = {
    url: '/uapi/v1/user/get-profile-url',
    type: API_TYPE.GET,
};

export const getProfileUrl = (params: GetProfileUrlParams) => {
    return fetchData(GET_PROFILE_URL, params);
};

export async function goUserProfile(id?: string, isStudentId = true) {
    try {
        if (!id) {
            return;
        }

        const params: { [key: string]: string } = {};
        params[isStudentId ? 'student_id' : 'umu_id'] = id;

        const {
            data: { profile_url },
        } = await getProfileUrl(params);

        if (isSafari || isIos || isAndroid) {
            window.location.href = profile_url;
            return;
        }

        $window.open(profile_url, '_blank');
    } catch (error) {
        console.error('goUserProfile error:', error);
    }
}
